import React from 'react';
import SharePopUp from "./SharePopUp.js";
import { Button, Navbar, NavItem, Nav } from 'react-bootstrap';

export default class Header  extends React.Component {
  render() {

    let links;
    const roomURL = this.props.match.url;

    if (roomURL.indexOf("/room") >= 0) {
      links = (
        <Nav pullRight>
          <NavItem eventKey={1} href="/codePlayground">
            Code Playground
          </NavItem>
          <li> <SharePopUp roomURL = {roomURL}/> </li>
        </Nav>
      )

    } else{
      links = (
        <Nav pullRight>
          <NavItem eventKey={2} href="/codePlayground">
            Code Playground
          </NavItem>
        </Nav>
      )
    }

    return (
      <Navbar className="navStyle" inverse collapseOnSelect fixedTop>
        <Navbar.Header>
          <Navbar.Brand>
            <a href="/"> &lt;techInterview/&gt;</a>
            </Navbar.Brand>
            <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse >

            {links}

        </Navbar.Collapse>
      </Navbar>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Header.js